import { NgModule } from "@angular/core";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { TamasAlunoService } from "../tamas-aluno.service";
//import { Produto, Categoria, Adicionais } from '../cardapio';
import { Router, ActivatedRoute } from "@angular/router";
import { AlertaConfirmDialog } from "../alerta-confirm";
import { AlertaSimplesDialog } from "../alerta-simples";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Location } from "@angular/common";

//declare let mySwiper: any;
declare let fakeVariable: any;
declare var Swiper: any;

//declare var Swiper: any;

@Component({
  selector: "app-perfil",
  templateUrl: "./perfil.component.html",
  styleUrls: ["./perfil.component.css"],
})
export class PerfilComponent implements OnInit, OnDestroy {
  @ViewChild("perfilHead") perfilHead1: ElementRef;
  shouldHide: boolean = true;
  shouldHide2: boolean = false;
  shouldHide3: boolean = true;
  produtoSelecionado: any[] = [];
  inputsearch: any = "";
  contadorAdmin: any = 0;
  hideCL: boolean = false;
  valorScroll: any = 0;
  valorMaximo: any = 0;
  valorScrollAt: any = 0;
  urlFoto: any = "";
  urlFotoSec: any = "";
  urlFeedPicture: any = "";
  fotoPerfil: any = "";
  arrFotos: any[] = [];
  arrProInfo: any[] = [];
  arrFeedPosts: any[] = [];
  uNome: any = "";
  uNick: any = "";
  uIdade: any = "";
  uAltura: any = "";
  eAltura: boolean = false;
  ePeso: boolean = false;
  eIdade: boolean = false;
  eLocal: boolean = false;
  uPeso: any = "";
  uLocal: any = "";
  uFrase: any = "";
  uNivel: any = "";
  uProfissao: any = "";
  userPro: boolean = false;
  arrPref: any[] = [];
  selfB: boolean = false;
  jaSigo: boolean = false;
  pArrModalidades: any[] = [];
  pArrProfissionais: any[] = [];
  pArrLocais: any[] = [];
  pNomeUsuario: any = "";
  slideLoaded = false;
  fakeSwiper: any;
  qtyET: any = 0;
  qtyTM: any = 0;
  loadMore: boolean = false;
  contadorIndex: any = 0;
  pendente: boolean = false;
  seeAll: boolean = false;
  backBC: boolean = false;
  constructor(
    public tmaService: TamasAlunoService,
    private _location: Location,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog
  ) {
    route.params.subscribe((val) => {
      this.tmaService.eventoFS(false);
      this.funcaoInicial();
    });
  }

  ngOnInit() {}

  funcaoInicial() {
    this.backBC = false;
    console.log("url array ", this.tmaService.gArrUrlPrev);
    //document.getElementsByClassName('interno_bloco1').scrollTo(0, 0);

    this.hideCL = false;
    this.pNomeUsuario = this.route.snapshot.paramMap.get("nomeusuario");
    //check palavras restritas para redirecionar
    if (this.pNomeUsuario == "resultados") {
      this.router.navigate(["/pesquisando/pessoas"]);
      return;
    }

    this.arrFeedPosts = [];
    this.buscarInfoUser(this.pNomeUsuario);
    if (this.pNomeUsuario == this.tmaService.hcNomeUsuario) {
      this.selfB = true;
    } else {
      // this.tmaService.eventoFS(true);
      this.selfB = false;
    }

    //destroy swipper

    // setTimeout(() => {
    //     this.perfilHead1.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }, 2000);
  }

  ngAfterViewInit() {}

  verificarView(): void {
    if (this.tmaService.gArrUrlPrev.length > 0) {
      if (
        this.tmaService.gArrUrlPrev[this.tmaService.gArrUrlPrev.length - 1]
          .destino == this.router.url
      ) {
        console.log("just pop");
        this.tmaService.gArrUrlPrev.pop();
      }
    }
  }
  carregarSlide(): void {
    //get window width
    if (window.innerWidth <= 650) {
      //script mobile
      setTimeout(() => {
        this.fakeSwiper = new Swiper(".swiper-container2", {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
        this.hideCL = true;
      }, 0);
    } else {
      setTimeout(() => {
        console.log("atualizar swiper");
        // if(this.fakeSwiper != undefined){
        //     this.fakeSwiper.destroy(true,true);
        // }
        this.fakeSwiper = new Swiper(".swiper-container2", {
          slidesPerView: 3,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
        this.hideCL = true;
      }, 0);
    }
  }

  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
    if (!this.backBC) {
      this.verificarView();
    }
  }

  loadScript2(url: string) {
    // if(!this.slideLoaded){
    //     console.log("call loadscript");
    //     this.slideLoaded = true;
    //     const body = <HTMLDivElement> document.body;
    //     const script = document.createElement('script');
    //     script.innerHTML = '';
    //     script.type = 'text/javascript';
    //     script.src = url;
    //     script.async = false;
    //     script.defer = true;
    //     body.appendChild(script);
    // }
    //swiper.update();
  }

  cfgScroll(qtdFotos: any): any {
    //scroll initilialize , call after img load
    //preciso pegar o width total da página
    let fullpagew = document.getElementById("content-area");

    let el = document.getElementById("fotoPrincipal");
    el.scrollTop = el.scrollHeight;
    console.log(el.scrollWidth);
    this.valorMaximo = el.scrollWidth * qtdFotos;
    this.valorScroll = el.scrollWidth;
    this.valorScrollAt = this.valorScroll;
    console.log(this.valorScroll, this.valorScrollAt, this.valorMaximo);
    console.log(
      fullpagew.offsetWidth,
      this.valorMaximo / fullpagew.offsetWidth
    );
    if (this.valorMaximo / fullpagew.offsetWidth < qtdFotos) {
      //significa que a resolução disponível é maior que 1 foto por vez, então o scroll deve ser diferente
      //talvez proporcional algo tipo 30% ? krai
      // deixar pra depois
    }
  }

  buscarInfoUser(qUsuario: any): void {
    //server side
    //this.slideLoaded = false;
    if (this.fakeSwiper != undefined) {
      this.fakeSwiper.destroy(true, true);
    }
    var dadosIn =
      "nomeusuario=" +
      qUsuario +
      "&email=" +
      this.tmaService.hcEmail +
      "&senha=" +
      this.tmaService.hcSenha;
    this.tmaService.listarPerfilP(dadosIn).subscribe((qRes) => {
      console.log(qRes);
      this.hideCL = true;
      if (qRes["res"] == "done") {
        if (qRes["tipo"] == "full") {
          this.seeAll = true;
          this.eAltura = qRes["dadosPref"].ExibirAltura;
          this.ePeso = qRes["dadosPref"].ExibirPeso;
          this.eLocal = qRes["dadosPref"].ExibirCidadeUF;
          this.arrProInfo = qRes["dadosPro"];
          this.uNome = qRes["dadosUsuario"].nome;
          this.uNick = qRes["dadosUsuario"].nickname;
          this.uIdade = qRes["idade"];
          this.jaSigo = qRes["imFlw"];
          this.qtyTM = qRes["nSeguidores"];
          this.qtyET = qRes["nSeguindo"];
          this.userPro = qRes["dadosUsuario"].userPro;
          this.arrFeedPosts = this.arrFeedPosts.concat(qRes["dadosFeed"]);
          this.contadorIndex += qRes["dadosFeed"].length;
          if (qRes["dadosFeed"].length < 6) {
            this.loadMore = false;
          } else {
            this.loadMore = true;
          }

          this.uAltura =
            qRes["dadosUsuario"].altura.toString().replace(".", "") + "cm";
          this.uPeso = qRes["dadosUsuario"].peso + "kg";
          this.uLocal =
            qRes["dadosUsuario"].cidade + "/" + qRes["dadosUsuario"].uf;
          this.fotoPerfil = qRes["dadosUsuario"].fotoPerfil;
          this.uFrase = qRes["dadosUsuario"].frasebio;
          this.uNivel = qRes["dadosUsuario"].nivel;
          this.uProfissao = qRes["dadosUsuario"].profissao;
          this.arrFotos = qRes["userFotos"];
          var totalF = qRes["userFotos"].length;
          this.pArrModalidades = qRes["dadosModal"];
          this.pArrLocais = qRes["dadosLoc"];
          this.pArrProfissionais = qRes["dadosPro"];
          if (this.fotoPerfil != "") {
            totalF += 1;
          }
          this.urlFoto =
            this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
          this.urlFotoSec =
            this.tmaService.urlRepositorioS3 + "/users-sec-picture/";
          this.urlFeedPicture =
            this.tmaService.urlRepositorioS3 + "/users-feed/";
          //this.cfgScroll(totalF);
          this.perfilHead1.nativeElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          this.hideCL = false;
          this.carregarSlide();
        } else {
          //privado e não segue
          this.seeAll = false;
          this.uNome = qRes["dadosUsuario"].nome;
          this.uNick = qRes["dadosUsuario"].nickname;
          this.fotoPerfil = qRes["dadosUsuario"].fotoPerfil;
          this.uProfissao = qRes["dadosUsuario"].profissao;
          this.jaSigo = qRes["imFlw"];
          totalF = 1;
          this.pendente = qRes["pendente"];
          this.urlFoto =
            this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        }
        //this.arrPref = qRes['dadosPref'];
      }
    });
  }

  goDetail(parametroDetail: any) {
    this.tmaService.gUrlAnterior =
      "/" + this.route.snapshot.paramMap.get("nomeusuario");
    this.router.navigate([
      "/" +
        this.route.snapshot.paramMap.get("nomeusuario") +
        "/" +
        parametroDetail,
    ]);
  }

  scrollNova(): void {
    if (this.valorScrollAt >= this.valorMaximo) {
      this.valorScrollAt = 0;
      var exPr = document.getElementById("blocofotos");
      console.log(exPr.offsetWidth);
      exPr.scrollLeft = this.valorScrollAt;
      this.valorScrollAt += this.valorScroll;
    } else {
      var exPr = document.getElementById("blocofotos");
      console.log(exPr.offsetWidth);
      exPr.scrollLeft = this.valorScrollAt;
      this.valorScrollAt += this.valorScroll;
    }
    //.scrollIntoView();
    // document.getElementById("content").scrollIntoView();
  }

  followup(): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      nomeusuarioTF: this.uNick,
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
    };
    this.tmaService.followUser(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.jaSigo = true;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  followremove(): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      nomeusuarioTR: this.uNick,
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
    };
    this.tmaService.unfollowUser(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.jaSigo = false;
          this.pendente = false;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  // compartilhar() : void{
  //     this.ngNavigatorShareService.share({
  //         title: 'Perfil de ' + this.uNome,
  //         text: 'Ei olha o meu perfil no Tamas',
  //         url: 'https://apptamasaluno.web.app/' + this.uNick
  //       }).then( (response) => {
  //         console.log(response);
  //       })
  //       .catch( (error) => {
  //         console.log(error);
  //       });
  // }
  share() {
    // this.ngNavigatorShareService.share({
    //     title: 'Perfil de ' + this.uNome,
    //     text: 'Ei olha o meu perfil no Tamas',
    //     url: 'https://tamasapp.com/' + this.uNick
    // }).then((response) => {
    //     console.log(response);
    // })
    //     .catch((error) => {
    //         console.log(error);
    //         //alert("lalalal");
    //         this.copyToClipboard('https://tamasapp.com/' + this.uNick);
    //         //window.prompt("Esse é o link do seu perfil: Ctrl+C, Enter", 'https://tamasapp.com/' + this.uNick);
    //     });
  }

  copyToClipboard(item) {
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", item);
      e.preventDefault();
      document.removeEventListener("copy", null);
    });
    document.execCommand("copy");
    const erroCriar = this.dialog.open(AlertaSimplesDialog, {
      disableClose: true,
      data: {
        tituloAlerta: "Link do Perfil",
        textoAlerta: "O link para o seu perfil foi copiado!",
        iconAlerta: "",
      },
    });
  }

  carregarFeed(): void {
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      numIndex: this.contadorIndex,
      nomeusuario: this.pNomeUsuario,
    };

    this.hideCL = false;
    this.tmaService.listarFeedSimp(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          //trazer posts feed
          this.arrFeedPosts = this.arrFeedPosts.concat(qRes["dadosFeed"]);
          this.contadorIndex += qRes["dadosFeed"].length;
          if (qRes["dadosFeed"].length < 6) {
            this.loadMore = false;
          } else {
            this.loadMore = true;
          }

          console.log(this.arrFeedPosts.length);
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  goLocal(nomeLocal: any): void {
    //this.tmaService.gUrlAnterior = this.router.url;
    this.tmaService.paginaAnterior = this.router.url;
    this.router.navigate(["/local/" + nomeLocal]);
  }
  goPerfil(nomeUser: any): void {
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(["/" + nomeUser]);
  }
  editPerfil(): void {
    this.tmaService.gUrlAnterior = "/" + this.uNick;
    this.router.navigate(["/me/perfil"]);
  }
  editFotos(): void {
    this.tmaService.gUrlAnterior = "/" + this.uNick;
    this.router.navigate(["/me/perfil/foto"]);
  }

  goSettings(): void {
    console.log("settings");
    this.tmaService.gUrlAnterior = "me/perfil";
    this.router.navigate(["/me/settings"]);
  }

  goChat(): void {
    this.tmaService.paginaAnterior = this.pNomeUsuario;
    this.router.navigate(["/me/i/" + this.pNomeUsuario]);
  }

  goPost(idpost: any): void {
    this.tmaService.gUrlAnterior = this.pNomeUsuario;
    this.router.navigate(["/me/post/" + this.pNomeUsuario + "/" + idpost]);
  }

  goNet(tipo: any): void {
    this.backBC = true;
    if (tipo == "tm") {
      this.tmaService.visualTT = "torcedores";
    } else {
      this.tmaService.visualTT = "torcendo";
    }

    this.router.navigate(["/" + this.pNomeUsuario + "/network"]);
  }

  logout(): void {
    const avisoIC = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {
        tituloAlerta: "Aviso",
        textoAlerta: "Desja efetuar o logout?",
        textoCancel: "Não",
        textoConfirm: "Sim",
      },
    });
    avisoIC.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == true) {
        this.tmaService.hcEmail = "";
        this.tmaService.hcSenha = "";
        this.tmaService.hcNomeUsuario = "";
        this.tmaService.logado = false;
        localStorage.removeItem("tmsDadosCliente");
        this.router.navigate(["/autenticar"]);
      }
    });
    console.log("sair");
  }

  voltar(): void {
    this.backBC = true;
    console.log(this.tmaService.gUrlAnterior);
    console.log("url pai ", this.tmaService.gArrUrlPrev);
    // if (this.tmaService.gUrlAnterior == this.router.url.substring(1, this.router.url.length) ||
    //     this.tmaService.gUrlAnterior.indexOf(this.router.url) != -1) {
    //     //go previous

    // }
    // else {

    //     if (this.tmaService.gUrlAnterior == '') {
    //         this.router.navigate(['/home']);
    //     }
    //     else {
    //         //this._location.back();
    //         console.log("whats happenin");
    //         console.log(this.tmaService.gUrlAnterior);
    //         console.log(this.router.url.substring(1, this.router.url.length));
    //         this.router.navigate([this.tmaService.gUrlAnterior]);
    //     }
    // }

    var urlParam1 = "";
    if (this.tmaService.gArrUrlPrev.length > 0) {
      if (this.tmaService.gArrUrlPrev.length == 1) {
        var ultUrl = this.tmaService.gArrUrlPrev[0].destino;
        this.tmaService.gArrUrlPrev.pop();
        //this.router.navigate([ultUrl + "/network"]);
        if (this.router.url == ultUrl) {
          urlParam1 = "";
        } else {
          urlParam1 = "/network";
        }
        this.router.navigate([ultUrl + urlParam1]);
      } else {
        //pop
        this.tmaService.gArrUrlPrev.pop();
        var ultUrl =
          this.tmaService.gArrUrlPrev[this.tmaService.gArrUrlPrev.length - 1]
            .destino;
        if (this.router.url == ultUrl) {
          urlParam1 = "";
        } else {
          urlParam1 = "/network";
        }
        this.router.navigate([ultUrl + urlParam1]);
      }
    } else {
      this.router.navigate(["/home"]);
    }
  }
}
